import { Theme } from '@emotion/react';
import { SxProps } from '@mui/system';

export const styles = {
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerFont: {
    fontSize: 18,
    fontWeight: 600,
  },
  filterContainer: {
    mb: 1,
  },
  uploadLead: {
    height: 32,
    minWidth: 140,
    whiteSpace: 'nowrap',
  },
  selectDropdown: { display: 'flex', alignItems: 'center' },
  selectContainer: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  actions: { display: 'flex', alignItems: 'center', gap: '12px' },
} satisfies Record<string, SxProps<Theme>>;
